module.exports = __webpack_public_path__ + "img/p4-2.7d619382.png";